import { createContext } from 'react'

const gitlabContext = createContext()

export default gitlabContext
